var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":_vm.primary,"height":"50px","width":"50px"}},[_c('div',{staticClass:"d-flex align-end justify-end fill-height"},[_c('v-card',{staticStyle:{"margin-right":"3px","margin-bottom":"3px"},attrs:{"color":_vm.secondary,"height":"15px","width":"15px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }